import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {IDepartment, IDepartmentRequest, IListDepartmentsRequest} from '../models/departement';
import {environment} from "../../../environments/environment";
import { IPagedResults } from 'src/app/core/models/base';

@Injectable({
  providedIn: 'root'
})
export class DepartementService {

  constructor(private http: HttpClient) { }

  listDepartements(request: IListDepartmentsRequest = null){
    return this.http.post<IPagedResults<IDepartment[]>>(
      `${environment.baseUrl}/v1/department/searchdepartments`,
      request
    )
  }

  addDepartement(request : IDepartmentRequest){
    return this.http.post<IDepartment>(
      `${environment.baseUrl}/v1/department/createdepartment`,
      request
    )
  }

  updateDepartement(request : IDepartmentRequest){
    return this.http.put<IDepartment>(
      `${environment.baseUrl}/v1/department/updatedepartment/${request.id}`,
      request
    )
  }

  deleteDepartement(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/department/deletedepartment/${id}`
    )
  }
}
